import React, { createContext } from "react";
import useApi from "../hooks/useApi";

const countries = [
  { value: "CH", label: "Switzerland" },
  { value: "FR", label: "France" },
  { value: "DE", label: "Germany" },
  { value: "IT", label: "Italy" }
];

const months = [
  { label: "January", value: 0 },
  { label: "February", value: 1 },
  { label: "March", value: 2 },
  { label: "April", value: 3 },
  { label: "May", value: 4 },
  { label: "June", value: 5 },
  { label: "July", value: 6 },
  { label: "August", value: 7 },
  { label: "September", value: 8 },
  { label: "October", value: 9 },
  { label: "November", value: 10 },
  { label: "December", value: 11 }
];

const experiences = {
  1: "Student",
  2: "0-5 years",
  3: "+5 years"
};

const regions = [
  { label: "Genève", value: "Genève" },
  { label: "Lausanne", value: "Lausanne" }
];

const TypesContext = createContext();
export default TypesContext;

export const TypesContextProvider = ({ children }) => {
  const { data: skills } = useApi("/skill");

  return (
    <TypesContext.Provider
      value={{ skills, countries, experiences, regions, months }}
    >
      {children}
    </TypesContext.Provider>
  );
};
